import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import UISelect from 'UIComponents/input/UISelect';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { GET_OBJECT_PROPERTIES_BY_GROUP } from 'automation-ui-references/object-type-properties/ObjectTypePropertyQueries';
import { findProperty, flattenPropertyGroups, isVisible, supportsPlainTextMatching, convertProperyToOption } from 'automation-ui-formula-editor/fetch-object-panel/utils/propertyUtils';
import AddDataSourceMatchingEnrolledPropertySelect from 'automation-ui-formula-editor/fetch-object-panel/containers/AddDataSourceMatchingEnrolledPropertySelect';
import AddDataSourceMatchingStaticValue from 'automation-ui-formula-editor/fetch-object-panel/containers/AddDataSourceMatchingStaticValue';
import { View } from 'foundations-components/components/View';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EMPTY_PROPERTY_GROUPS = [];
const AddDataEnrolledPropertyMatch = ({
  flowObjectTypeId,
  onEnrolledPropertyChange,
  onDataSourcePropertyChange,
  onMatchingPropertyValueChange,
  dataSourcePropertyName,
  matchingValue,
  toObjectTypeId,
  readOnly
}) => {
  var _dataSourcePropertyDa, _matchingValue$fieldN;
  const {
    data: dataSourcePropertyData,
    loading: dataSourcePropertiesLoading
  } = useQuery(GET_OBJECT_PROPERTIES_BY_GROUP, {
    variables: {
      objectTypeId: toObjectTypeId
    }
  });
  const dataSourcePropertiesByGroup = (_dataSourcePropertyDa = dataSourcePropertyData === null || dataSourcePropertyData === void 0 ? void 0 : dataSourcePropertyData.automation_propertiesByGroup) !== null && _dataSourcePropertyDa !== void 0 ? _dataSourcePropertyDa : EMPTY_PROPERTY_GROUPS;
  const dataSourceProperty = dataSourcePropertyName ? findProperty(dataSourcePropertyName, dataSourcePropertiesByGroup) : undefined;
  const dataSourcePropertyOptions = useMemo(() => flattenPropertyGroups(dataSourcePropertiesByGroup).filter(isVisible).filter(supportsPlainTextMatching).map(convertProperyToOption), [dataSourcePropertiesByGroup]);
  const handleChangeDataSourceProperty = event => {
    onDataSourcePropertyChange(event.target.value);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "p-top-5 m-bottom-3",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.property-matching.title"
    }), /*#__PURE__*/_jsxs(View, {
      borderInlineStartWidth: "300",
      borderInlineStartStyle: "solid",
      borderInlineStartColor: "border-core-subtle",
      marginInlineStart: "500",
      paddingInlineStart: "500",
      marginBlock: "400",
      children: [/*#__PURE__*/_jsx(UISelect, {
        disabled: dataSourcePropertiesLoading,
        isLoading: dataSourcePropertiesLoading,
        onChange: handleChangeDataSourceProperty,
        options: dataSourcePropertyOptions,
        value: dataSourcePropertyName,
        readOnly: readOnly,
        placeholder: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.property-matching.data-source-property-placeholder_cob",
          objectTypeId: toObjectTypeId
        })
      }), /*#__PURE__*/_jsx(Text, {
        marginBlock: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: (matchingValue === null || matchingValue === void 0 ? void 0 : matchingValue.type) === 'STATIC' ? 'automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.property-matching.equals' : 'automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.property-matching.has-same-value'
        })
      }), (matchingValue === null || matchingValue === void 0 ? void 0 : matchingValue.type) === 'STATIC' ? /*#__PURE__*/_jsx(AddDataSourceMatchingStaticValue, {
        dataSourcePropertyName: dataSourcePropertyName,
        dataSourceProperty: dataSourceProperty,
        value: matchingValue.value,
        onChange: onMatchingPropertyValueChange,
        dataSourceObjectTypeId: toObjectTypeId,
        readOnly: readOnly
      }) : /*#__PURE__*/_jsx(AddDataSourceMatchingEnrolledPropertySelect, {
        flowObjectTypeId: flowObjectTypeId,
        dataSourceProperty: dataSourceProperty,
        enrolledPropertyName: (_matchingValue$fieldN = matchingValue === null || matchingValue === void 0 ? void 0 : matchingValue.fieldName) !== null && _matchingValue$fieldN !== void 0 ? _matchingValue$fieldN : null,
        onEnrolledPropertyChange: onEnrolledPropertyChange,
        readOnly: readOnly
      })]
    })]
  });
};
export default AddDataEnrolledPropertyMatch;